import MaterialList from '../components/MaterialList/MaterialList';
import Subjects from '../components/Subjects/Subjects';
import AdminDashboard from '../pages/AdminDashboard/AdminDashboard';
import AdminLoginPage from '../pages/AdminLoginPage/AdminLoginPage';
import AdminProfile from '../pages/AdminProfile/AdminProfile';
import LandingPage from '../pages/LandingPage/LandingPage';
import TeacherSelectClass from '../pages/TeacherSelectClass/TeacherSelectClass';
import TeacherStudentClassroom from '../pages/TeacherStudentClassroom/TeacherStudentClassroom';
import { useAppSelector } from '../redux/app/hooks';
import { JITSI, PATH_ADDRESSES, PTA_ROLE, SCHOOL_ADMIN, STUDENT_ROLE, TEACHER_ROLE, VIRTUAL } from '../utils/constants'
import TeacherTeachingMaterial from '../pages/TeacherTeachingMaterial/TeacherTeachingMaterial';
import TeacherExaminationGuide from '../pages/TeacherExaminationGuides/TeacherExaminationGuides';
import LiveClass from '../pages/LiveClass/LiveClass';
import ImageMaterial from '../pages/ImageMaterial/ImageMaterial';
import QuestionBank from '../pages/QuestionBank/QuestionBank';
import PodCast from '../pages/PodCast/PodCast';
import Quiz from '../pages/Quiz/Quiz';
import Workshop from '../pages/Workshop/Workshop';
import SyndicatedVideos from '../pages/SyndicatedVideos/SyndicatedVideos';
import TestPage from '../components/TestPage/TestPage';
import StudentQuizResults from '../components/StudentQuizResults/StudentQuizResults';
import Calendar from '../pages/Calendar/Calendar';
import AdminAnnouncement from '../pages/AdminAnnouncement/AdminAnnouncement';
import Assignments from '../pages/Assignments/Assignments';
import CommonChats from '../pages/CommonChats/CommonChats';
import TeacherStudentSettings from '../pages/TeacherStudentSettings/TeacherStudentSettings';
import StudentProfile from '../pages/StudentProfile/StudentProfile';
import AdminNotification from '../pages/AdminNotification/AdminNotification';
import AdminSystemMessages from '../pages/AdminSystemMessages/AdminSystemMessages';
import AdminSettings from '../pages/AdminSettings/AdminSettings';
import AdminPayments from '../pages/AdminPayments/AdminPayments';
import Help from '../pages/Help/Help';
import TermsAndPrivacyPolicy from '../pages/Help/TermsAndPrivacyPolicy';
import Support from '../pages/Support/Support';
import TeacherProfile from '../pages/TeacherProfile/TeacherProfile';
import SchoolProfile from '../pages/SchoolProfile/SchoolProfile';
import Legal from '../pages/Legal/Legal';
import Faq from '../pages/Faq/Faq';
import AdminPta from '../pages/AdminPta/AdminPta';
import PtaMeetings from '../pages/PtaMeetings/PtaMeetings';
import HelpCenter from '../pages/Help/HelpCenter';
import ChimeMeeting from '../components/ChimeMeeting/ChimeMeeting';
import DownloadsList from '../pages/StudentDownloads/DownloadsList';
import InAppDownloads from '../pages/InAppDownloads/InAppDownloads';
import UnderConstruction from '../components/UnderConstruction/UnderConstruction';
import { JitsiConference } from '../Jitsi/JitsiConference';
import { JitsiConferenceReactSdk } from '../Jitsi/JitsiConferenceReactSdk';
import { useLocation } from 'react-router-dom';
import { JitsiConferenceCustomUI } from '../Jitsi/JitsiConferenceCustomUI';
import AdminMaterials from '../pages/AdminMaterials/AdminMaterials';
import AdminMaterialsList from '../pages/AdminMaterials/components/AdminMaterialsList';
import AdminBulkUpload from '../pages/AdminBulkUpload/AdminBulkUpload';
import PreChimeMeeting from '../components/ChimeMeeting/PreChimeMeeting';

export type navigationPropertiesTypes ={
    path: string,
    component: React.FC

}
type navigationType ={
    public : navigationPropertiesTypes[],
    private: navigationPropertiesTypes[],
    meet: navigationPropertiesTypes[]
}

export const useNavigation =()=>{
  const { role, loginpage} = useAppSelector((state) => state.auth);
  const isKaton = useAppSelector((state) => state.auth.isKaton);
  const { meetService, meetServiceOrganization } = useAppSelector((state) => state.auth)  
  const schoolType = useAppSelector((state) => state.auth.schoolType);
  const location = useLocation();
  const params = new URLSearchParams(location?.search);
  const isKatonParam = params.get('isKaton');

  console.log({ location });
  
  const navigation: navigationType = {
    public: [
      {
        path: "/",
        component: LandingPage,
      },
      {
        path: "/admin-login",
        component: AdminLoginPage,
      },
      {
        path: "/teacher-login",
        component: AdminLoginPage,
      },
      {
        path: "/teacher-select-class",
        component: TeacherSelectClass,
      },
      {
        path: "/pta-signup",
        component: AdminLoginPage,
      },
      {
        path: "/pta-login",
        component: AdminLoginPage,
      },
      {
        path: "/pta-verifyCode",
        component: AdminLoginPage,
      },
      {
        path: "/student-signup",
        component: AdminLoginPage,
      },
      {
        path: "/student-login",
        component: AdminLoginPage,
      },
      {
        path: "/student-verifyCode",
        component: AdminLoginPage,
      },
      {
        path: "/student-forgot-password",
        component: AdminLoginPage,
      },
      {
        path: "/faq",
        component: Faq,
      },
      {
        path: "/legal",
        component: Legal,
      },
      {
        path: "/support",
        component: Support,
      },
      {
        path: "/virtual-school",
        component: LandingPage,
      },
      {
        path: "/virtual-school/virtual-signup",
        component: AdminLoginPage,
      },
      {
        path: "/virtual-school/virtual-login",
        component: AdminLoginPage,
      },
      {
        path: "/virtual-school/virtual-forgot-password",
        component: AdminLoginPage,
      },
      {
        path: "/virtual-school/payment-success",
        component: AdminLoginPage,
      },
      {
        path: "/virtual-school/payment-failure",
        component: AdminLoginPage,
      },
      {
        path: "/virtual-school/payment-cancel",
        component: AdminLoginPage,
      }
    ],
    private:
      role === SCHOOL_ADMIN
        ? [
            {
              path: "/admin-dashboard",
              component: AdminDashboard,
            },
            {
              path: "/admin-school",
              component: AdminProfile,
            },
            {
              path: "/admin-workshop",
              component: Workshop,
            },
            {
              path: "/admin-calendar",
              component: Calendar,
            },
            {
              path: "/admin-notification",
              component: AdminNotification,
            },
            {
              path: "/admin-settings",
              component: AdminSettings,
            },
            {
              path: "/admin-materials-upload",
              component: AdminMaterials,
            },
            {
              path: "/admin-materials-upload/materials",
              component: AdminMaterialsList,
            },
            {
              path: "/admin-materials-upload/bulk-upload",
              component: AdminBulkUpload,
            },
            ...(schoolType === VIRTUAL
              ? [
                  {
                    path: "/admin-payments",
                    component: AdminPayments,
                  },
                ]
              : []
            ),
            {
              path: "/admin-help",
              component: Help,
            },
            {
              path: "/admin-help/admin-terms-and-privacy-policy",
              component: TermsAndPrivacyPolicy,
            },
            {
              path: "/admin-help/help-center",
              component: HelpCenter,
            },
            {
              path: "/admin-system-message",
              component: AdminSystemMessages,
            },
            {
              path: "/admin-pta",
              component: AdminPta,
            },
            {
              path: "/admin-pta/meetings",
              component: PtaMeetings,
            },
            {
              path: "/admin-pta/meetings",
              component: PtaMeetings,
            },

            //ADMIN MATERIALS ROUTES
            {
              path: "/admin-materials-upload/materials/ebooks",
              component: Subjects,
            },
            {
              path: "/admin-materials-upload/materials/images",
              component: Subjects,
            },
            {
              path: "/admin-materials-upload/materials/videos",
              component: Subjects,
            },
            {
              path: "/admin-materials-upload/materials/ebooks/materials",
              component: MaterialList,
            },
            {
              path: "/admin-materials-upload/materials/images/materials",
              component: ImageMaterial,
            },
            {
              path: "/admin-materials-upload/materials/videos/materials",
              component: SyndicatedVideos,
            },
            {
              path: "/admin-materials-upload/materials/ebooks/materials/teaching-materials",
              component: TeacherTeachingMaterial,
            },
            {
              path: "/admin-materials-upload/materials/ebooks/materials/examination-guide",
              component: TeacherExaminationGuide,
            },
            {
              path: "/admin-materials-upload/materials/ebooks/materials/question-bank",
              component: QuestionBank,
            },
            {
              path: "/admin-materials-upload/materials/podcast",
              component: Subjects,
            },
            {
              path: "/admin-materials-upload/materials/podcast/materials",
              component: PodCast,
            },
          ]
        : (role === TEACHER_ROLE)
        ? [
            {
              path: "/teacher-classroom",
              component: TeacherStudentClassroom,
            },
            {
              path: "/teacher-classroom/ebooks",
              component: Subjects,
            },
            {
              path: "/teacher-classroom/images",
              component: Subjects,
            },
            {
              path: "/teacher-classroom/podcast",
              component: Subjects,
            },
            {
              path: "/teacher-classroom/podcast/materials",
              component: PodCast,
            },
            {
              path: "/teacher-classroom/videos",
              component: Subjects,
            },
            {
              path: "/teacher-classroom/ebooks/materials",
              component: MaterialList,
            },
            {
              path: "/teacher-classroom/images/materials",
              component: ImageMaterial,
            },
            {
              path: "/teacher-classroom/videos/materials",
              component: SyndicatedVideos,
            },
            {
              path: "/teacher-calendar",
              component: Calendar,
            },
            {
              path: "/teacher-announcement",
              component: AdminAnnouncement,
            },
            {
              path: "/teacher-classroom/ebooks/materials/teaching-materials",
              component: TeacherTeachingMaterial,
            },
            {
              path: "/teacher-classroom/ebooks/materials/examination-guide",
              component: TeacherExaminationGuide,
            },
            {
              path: "/teacher-classroom/ebooks/materials/question-bank",
              component: QuestionBank,
            },
            {
              path: "/teacher-classroom/liveclass",
              component: LiveClass,
            },
            {
              path: "/teacher-classroom/quiz",
              component: Quiz,
            },
            {
              path: "/teacher-classroom/assignments",
              component: Assignments,
            },
            {
              path: "/teacher-classroom/quiz/test",
              component: TestPage,
            },
            {
              path: "/teacher-classroom/chats",
              component: CommonChats,
            },
            {
              path: "/teacher-workshop",
              component: Workshop,
            },
            {
              path: "/teacher-pta",
              component: PtaMeetings,
            },
            {
              path: "/teacher-settings",
              component: TeacherStudentSettings,
            },
            {
              path: "/teacher-help",
              component: Help,
            },
            {
              path: "/teacher-help/teacher-terms-and-privacy-policy",
              component: TermsAndPrivacyPolicy,
            },
            {
              path: "/teacher-help/help-center",
              component: HelpCenter,
            },
            {
              path: "/teacher-settings/profile",
              component: TeacherProfile,
            },
            {
              path: PATH_ADDRESSES?.SCHOOL_PROFILE_PATH,
              component: SchoolProfile,
            },
            {
              path: "/teacher-InAppdownloads",
              component: InAppDownloads,
            },
            {
              path: "/teacher-downloads",
              component: DownloadsList,
            },
          ]
        : (role === STUDENT_ROLE)
        ? [
            {
              path: "/underConstruction",
              component: UnderConstruction,
            },
            {
              path: "/student-classroom",
              component: TeacherStudentClassroom,
            },
            {
              path: "/student-settings",
              component: TeacherStudentSettings,
            },
            {
              path: "/student-settings/profile",
              component: StudentProfile,
            },
            {
              path: "/student-classroom/ebooks",
              component: Subjects,
            },
            {
              path: "/student-classroom/images",
              component: Subjects,
            },
            {
              path: "/student-classroom/videos",
              component: Subjects,
            },
            {
              path: "/student-classroom/ebooks/materials",
              component: MaterialList,
            },
            {
              path: "/student-classroom/images/materials",
              component: ImageMaterial,
            },
            {
              path: "/student-classroom/videos/materials",
              component: SyndicatedVideos,
            },
            {
              path: "/student-classroom/ebooks/materials/learning-materials",
              component: TeacherTeachingMaterial,
            },
            {
              path: "/student-classroom/ebooks/materials/examination-guide",
              component: TeacherExaminationGuide,
            },
            {
              path: "/student-classroom/ebooks/materials/question-bank",
              component: QuestionBank,
            },
            {
              path: "/student-classroom/question-bank/test",
              component: TestPage,
            },
            {
              path: "/student-classroom/question-bank/view",
              component: StudentQuizResults,
            },
            {
              path: "/student-classroom/quiz",
              component: Quiz,
            },
            {
              path: "/student-classroom/quiz/test",
              component: TestPage,
            },
            {
              path: "/student-classroom/quiz/view",
              component: StudentQuizResults,
            },
            {
              path: "/student-classroom/chats",
              component: CommonChats,
            },
            {
              path: "/student-classroom/liveclass",
              component: LiveClass,
            },
            {
              path: "/student-classroom/assignments",
              component: Assignments,
            },
            {
              path: "/student-classroom/podcast",
              component: Subjects,
            },
            {
              path: "/student-classroom/podcast/materials",
              component: PodCast,
            },
            {
              path: "/student-calendar",
              component: Calendar,
            },
            {
              path: "/student-announcement",
              component: AdminAnnouncement,
            },
            {
              path: "/student-help",
              component: Help,
            },
            {
              path: "/student-help/student-terms-and-privacy-policy",
              component: TermsAndPrivacyPolicy,
            },
            {
              path: "/student-help/help-center",
              component: HelpCenter,
            },
            {
              path: PATH_ADDRESSES?.SCHOOL_PROFILE_PATH,
              component: SchoolProfile,
            },
            {
              path: "/student-downloads",
              component: DownloadsList,
            },
            {
              path: "/student-InAppdownloads",
              component: InAppDownloads,
            }
          ]
        : (role === PTA_ROLE)
        ? [
            {
              path: "/pta-meetings",
              component: PtaMeetings,
            },
            {
              path: PATH_ADDRESSES?.SCHOOL_PROFILE_PATH,
              component: SchoolProfile,
            },
          ]
        : [],
    meet:
      (role === TEACHER_ROLE)
        ? [
            {
              path: "/teacher-classroom/liveclass/premeeting",
              component: PreChimeMeeting,
            },
            {
              path: "/teacher-workshop/premeeting",
              component: PreChimeMeeting,
            },
            {
              path: "/teacher/pta/premeeting",
              component: PreChimeMeeting,
            },
            {
              path: "/teacher-classroom/liveclass/meeting",
              component:
                meetService === JITSI ? JitsiConferenceCustomUI : ChimeMeeting,
            },
            {
              path: "/teacher-workshop/meeting",
              component:
                meetService === JITSI ? JitsiConferenceCustomUI : ChimeMeeting,
            },
            {
              path: "/teacher/pta/meeting",
              component:
                meetService === JITSI ? JitsiConferenceCustomUI : ChimeMeeting,
            },
          ]
        : (role === SCHOOL_ADMIN)
        ? [
            {
              path: "/admin-workshop/premeeting",
              component:
                PreChimeMeeting,
            },
            {
              path: "/admin/pta/premeeting",
              component:
                PreChimeMeeting,
            },
            {
              path: "/admin-workshop/meeting",
              component:
                meetService === JITSI ? JitsiConferenceCustomUI : ChimeMeeting,
            },
            {
              path: "/admin/pta/meeting",
              component:
                meetService === JITSI ? JitsiConferenceCustomUI : ChimeMeeting,
            },
          ]
        : (role === STUDENT_ROLE)
        ? [
            {
              path: "/student-classroom/liveclass/premeeting",
              component:
                PreChimeMeeting,
            },
            {
              path: "/student-classroom/liveclass/meeting",
              component:
                meetService === JITSI ? JitsiConferenceCustomUI : ChimeMeeting,
            },
          ]
        : (role === PTA_ROLE) ? [
            {
              path: "/pta/premeeting",
              component:
                PreChimeMeeting,
            },
            {
              path: "/pta/meeting",
              component:
                meetService === JITSI ? JitsiConferenceCustomUI : ChimeMeeting,
            },
          ] : [],
  };
  return { navigation };
}